/** Cross-module routes available from any ERP workspace. */
export const GLOBAL_WORKSPACE_ROUTES = ['/work', '/work/executive', '/notifications'] as const;

export function isGlobalWorkspaceRoute(pathname: string): boolean {
  const path = pathname.split('?')[0];
  return GLOBAL_WORKSPACE_ROUTES.some((r) => path === r || path.startsWith(`${r}/`));
}
